"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _styles = require("@material-ui/core/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _pittaModules = require("@thingsw/pitta-modules");
var _Typography = require("./Typography");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    link: {
      cursor: "pointer",
      color: function color(props) {
        var color = props.color;
        if (color === "secondary") {
          return _pittaModules.LightColors.primary["3"];
        } else if (color === "dangerous") {
          return _pittaModules.LightColors.secondary["11"];
        } else if (color === "white") {
          return _pittaModules.LightColors.primary["0"];
        } else {
          return _pittaModules.LightColors.primary["7"];
        }
      },
      textDecoration: "none",
      "&:hover": {
        color: function color(props) {
          var color = props.color;
          if (color === "dangerous") {
            return _pittaModules.LightColors.secondary["12"];
          } else {
            return _pittaModules.LightColors.primary["8"];
          }
        }
      },
      "&:active": {
        color: function color(props) {
          var color = props.color;
          if (color === "dangerous") {
            return _pittaModules.LightColors.secondary["12"];
          } else {
            return _pittaModules.LightColors.primary["8"];
          }
        }
      }
    },
    disabled: {
      cursor: "auto",
      opacity: 0.35,
      "&:hover": {
        color: function color(props) {
          var color = props.color;
          if (color === "secondary") {
            return _pittaModules.LightColors.primary["3"];
          } else if (color === "dangerous") {
            return _pittaModules.LightColors.secondary["11"];
          } else if (color === "white") {
            return _pittaModules.LightColors.primary["0"];
          } else {
            return _pittaModules.LightColors.primary["7"];
          }
        }
      }
    }
  };
});
var Link = function Link(props) {
  var classes = useStyles(props);
  var to = props.to,
    children = props.children,
    category = props.category,
    variant = props.variant,
    mode = props.mode,
    onClick = props.onClick,
    target = props.target,
    rel = props.rel,
    disable = props.disable;
  return mode === "anchor" ? /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _clsx2.default)(classes.link, _defineProperty({}, classes.disabled, disable)),
    onClick: disable ? undefined : onClick,
    href: to,
    target: target,
    rel: rel
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: category,
    variant: variant
  }, children)) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: classes.link,
    onClick: onClick,
    to: to !== null && to !== void 0 ? to : "/"
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: category,
    variant: variant
  }, children));
};
exports.Link = Link;